import { CopyPlus, PanelRightOpen, Plus, Search, Trash2 } from "lucide-react";
import { Button, Segmented } from "../../../../components/ui";
import { COLUMN_GROUPS } from "./takeoff-columns";

function Legend() {
  const sw = "inline-block h-3 w-3 rounded-[2px] border border-border";
  return (
    <div className="hidden items-center gap-3 text-[11px] text-text_muted xl:flex" aria-label="Cell legend">
      <span className="flex items-center gap-1"><span className={`${sw} bg-surface`} /> Editable</span>
      <span className="flex items-center gap-1"><span className={`${sw} bg-surface_alt`} /> Calculated</span>
      <span className="flex items-center gap-1"><span className="font-semibold text-info">Blue</span> = overridden default</span>
    </div>
  );
}

export default function TakeoffToolbar({
  search, onSearch, filter, onFilter, counts, groups, onToggleGroup, locked, hasSelection,
  onAdd, onDuplicate, onDelete, inspectorOpen, onToggleInspector,
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <div className="flex flex-wrap items-center gap-2">
        <div className="relative">
          <Search size={13} className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-text_muted" aria-hidden="true" />
          <input
            type="search"
            value={search}
            onChange={(e) => onSearch(e.target.value)}
            placeholder="Filter lines…"
            aria-label="Filter takeoff lines"
            className="h-8 w-52 rounded-[4px] border border-border bg-surface pl-8 pr-2 text-[12.5px] text-text_primary placeholder:text-text_muted focus:outline-none focus:border-border_strong"
          />
        </div>
        <Segmented
          size="xs"
          ariaLabel="Line filter"
          value={filter}
          onChange={onFilter}
          options={[
            { value: "all", label: "All", count: counts.all },
            { value: "errors", label: "Needs attention", count: counts.errors },
            { value: "overridden", label: "Overridden", count: counts.overridden },
          ]}
        />
        <div className="flex items-center gap-1" role="group" aria-label="Column groups">
          <span className="mr-1 text-[11px] text-text_muted">Columns:</span>
          {COLUMN_GROUPS.map((g) => (
            <button
              key={g.key}
              type="button"
              aria-pressed={groups[g.key]}
              onClick={() => onToggleGroup(g.key)}
              className={`h-7 rounded-[4px] border px-2 text-[11.5px] font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-border_strong ${
                groups[g.key] ? "border-primary bg-primary_tint text-primary" : "border-border bg-surface text-text_muted"
              }`}
            >
              {g.label}
            </button>
          ))}
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Legend />
        {!locked && (
          <>
            <Button size="xs" icon={Plus} onClick={onAdd}>Add line</Button>
            <Button size="xs" icon={CopyPlus} onClick={onDuplicate} disabled={!hasSelection}>Duplicate</Button>
            <Button size="xs" variant="danger" icon={Trash2} onClick={onDelete} disabled={!hasSelection}>Delete</Button>
          </>
        )}
        <Button size="xs" variant={inspectorOpen ? "primary" : "secondary"} icon={PanelRightOpen} onClick={onToggleInspector} aria-pressed={inspectorOpen}>
          Inspector
        </Button>
      </div>
    </div>
  );
}
